import React, {PureComponent, Ref} from "react"

import {FormattedMessage} from "@irati/utils/lang"

import {Body, H3} from "../Typography"
import Button from "../Button"
import PopUpWithImage from "../PopUpWithImage"

import Flex from "../Flex"

interface Props {
  headerText?: string,
  cancelButtonText: string,
  confirmButtonText: string,
  headerBody: string,
  onCancel: () => void,
  onConfirm: () => void,
  cancelImage: string
}

class CancellationPopup extends PureComponent<Props> {
  static defaultProps: Pick<Props, "headerText"> = {
    headerText: "perks.components.cancellationPopUp.headerText"
  }

  popup: Ref<PopUpWithImage> = null

  render() {
    const {onCancel, cancelButtonText, onConfirm, confirmButtonText, headerText, headerBody, cancelImage} = this.props

    return (
      <PopUpWithImage
        ref={(c: Ref<PopUpWithImage>) => {
          this.popup = c
        }}
        img={cancelImage}
        maxWidth="650px">
        <H3 marginBottom>
          <FormattedMessage id={headerText} />
        </H3>
        <Body small marginBottom={3}>{headerBody}</Body>
        <Flex justifyContent="flex-end">
          <Button tertiary onClick={onCancel} marginRight>
            {cancelButtonText}
          </Button>
          <Button primary onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </Flex>
      </PopUpWithImage>
    )
  }
}

export default CancellationPopup
